import React, { useState, useEffect, useMemo } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebase';

// Define categories array outside component to prevent re-creation on each render
const CATEGORIES = [
  "Technology", "Business", "Lifestyle", "Health", 
  "Travel", "Food", "Education", "Other"
];

// Categories Widget Component
const CategoriesWidget = () => {
  const [categoryCounts, setCategoryCounts] = useState({});
  const [loading, setLoading] = useState(true);
  
  // Use useMemo to memoize the categories array
  const categories = useMemo(() => CATEGORIES, []);

  useEffect(() => {
    const fetchCategoryCounts = async () => {
      try {
        const counts = {};
        
        // Initialize all categories with 0 count
        categories.forEach(category => {
          counts[category] = 0;
        });
        
        // Fetch all blog posts
        const postsRef = collection(db, 'blogPosts');
        const postsSnapshot = await getDocs(postsRef);
        
        // Count posts by category
        postsSnapshot.docs.forEach(doc => {
          const postData = doc.data();
          if (postData.category) {
            // If category exists in our list, increment the count
            if (counts[postData.category] !== undefined) {
              counts[postData.category]++;
            } else {
              // If it's not in our predefined list, add to "Other"
              counts["Other"]++;
            }
          }
        });
        
        setCategoryCounts(counts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching category counts:", error);
        setLoading(false);
      }
    };
    
    fetchCategoryCounts();
  }, [categories]);

  return (
    <div className="categories-widget widget-item">
      <h3 className="widget-title">Categories</h3>
      <ul className="mt-3">
        {loading ? (
          <li>Loading categories...</li>
        ) : (
          categories.map(category => (
            <li key={category}>
              <a href={`/blog?category=${encodeURIComponent(category)}`}>
                {category} <span>({categoryCounts[category] || 0})</span>
              </a>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default CategoriesWidget;